import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center flex flex-col items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  href: "mailto:hello@radohlavaty.com",
  class: "group inline-flex items-center gap-2 px-6 py-2 underline hover:no-underline font-semibold rounded-xl transition-all duration-300 hover:shadow-sm hover:bg-gray-100/80 text-gray-900"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.profilePic,
      alt: "Radovan Hlavatý",
      class: "rounded-full w-64 h-64 object-cover mb-4"
    }, null, 8, _hoisted_2),
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-xl font-bold uppercase mb-2" }, "Radovan Hlavatý", -1)),
    _createElementVNode("a", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, {
        icon: "fa-regular fa-envelope",
        class: "group-hover:animate-wiggle-scale"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sayHello")), 1)
    ])
  ]))
}